import { IoIosArrowDown } from 'react-icons/io';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Card: any = styled.div`
  display: flex;
  padding: 16px;
  margin-bottom: 10px;
  border-radius: 8px;
  flex-direction: column;
  box-shadow: 0 2px 16px 0 ${({ theme }) => theme.flightDetails.card.boxShadow};
  background: ${ColorPalette.HEX.White};
`;

Card.Title = styled.h4`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.71;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: ${({ theme }) => theme.flightDetails.card.title};
`;

Card.Row = styled.div`
  display: flex;
  cursor: pointer;
  font-size: 10px;
  align-items: center;
  justify-content: space-between;
  color: ${({ theme }) => theme.flightSector.color};
`;

Card.Arrow = styled(IoIosArrowDown)`
  font-size: 20px;
  padding: 0 2px;
  box-sizing: content-box;
  color: ${({ theme }) => theme.flightDetails.card.arrowDown} !important;

  &.active {
    transform: rotate(-180deg);
  }
`;

export const CardContentContainer = styled.div`
  & > div {
    border-bottom: solid 1px ${({ theme }) => theme.flightDetails.cancellationPolicies.cardContent};

    &:last-child {
      border: 0;
    }
  }
`;

export const CardContent: any = styled.div`
  padding: 16px 0;
`;

CardContent.PolicyRow = styled.p`
  margin: 8px 0;
`;

CardContent.FlightLabel = styled.span`
  margin: 18px 0;
  font-size: 14px;
  line-height: 1.14;
  font-style: normal;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: ${({ theme }) => theme.flightDetails.cancellationPolicies.label};
`;

CardContent.FlightPolicy = styled.span`
  display: unset;
  font-size: 12px;
  color: ${({ theme }) => theme.flightDetails.cancellationPolicies.policy};
`;

CardContent.FlightPolicyValue = styled.span`
  display: unset;
  font-size: 12px;
  color: ${({ theme }) => theme.flightDetails.cancellationPolicies.policyValue};
`;

CardContent.Disclaimer = styled.div`
  font-size: 10px;
  line-height: 1.4;
  font-style: normal;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: normal;
  margin: 24px 0 12px 0;
  color: ${({ theme }) => theme.flightDetails.cancellationPolicies.disclaimer};
`;
